import { TableBody, TableCell } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useAttendance } from '../../../hooks/Features/useAttendance'
import { itemsPerPage } from '../../../shared/data'
import CustomModal from '../../CustomModal'
import CustomPagination from '../../CustomPagination'
import Layout from '../../Layout'
import Loader from '../../Loader'
import { NoDataFound } from '../../NoDataFound'
import CustomTable from '../../Table/CustomTable'
import CustomTableHeading from '../../Table/CustomTableHeading'
import CustomTableRow from '../../Table/CustomTableRow'
import styles from '../reports.module.css'
import { SortIcon, FilterIcon } from '../../CustomComponents/CustomFilterIcon'

export default function MonthlyLateReport() {
  const { getAttendanceMonthlyLateReport, attendance, loading } = useAttendance()
  const [page, setPage] = useState(1)
  const startDate = new Date()
  startDate.setDate(1);
  startDate.setHours(0, 0, 0)
  const [from, setFrom] = useState(startDate.toISOString())
  const [to, setTo] = useState(new Date().toISOString())
  const [open, setOpen] = useState(false)
  const [content, setContent] = useState([])
  const [filterParams, setFilterParams] = useState({})


  useEffect(() => {
    setPage(1)
    getAttendanceMonthlyLateReport({ from, to, ...filterParams })
  }, [from, to, filterParams])

  const noOfPages = Math.ceil(attendance && attendance.length / itemsPerPage)
  const handleChange = (event, value) => {
    setPage(value)
  }

  const handleClick = (item) => {
    if (item.length) {
      setContent(item)
      setOpen(true)
    }
  }

  const heading = [
    { label: 'Region', key: 'region' },
    { label: 'Zone', key: 'zone' },
    { label: 'State', key: 'state' },
    { label: 'District', key: 'district' },
    { label: 'City', key: 'city' },
    { label: 'TSM', key: 'tsm' },
    { label: 'Late<5', key: 'late5' },
    { label: 'Late<=6-10', key: 'late610' },
    { label: 'Late>10', key: 'late10' },
  ]

  let tempAttendance = []
  attendance &&
    attendance.forEach((item) =>
      tempAttendance.push({
        region: item.region && item.region.name,
        zone: item.zone && item.zone.name,
        state: item.state && item.state.name,
        district: item.district && item.district.name,
        city: item.city && item.city.name,
        tsm: item.name,
        late5: item.late5 && item.late5.join(),
        late610: item.late610 && item.late610.join(),
        late10: item.late10 && item.late10.join(),
      })
    )


  const initialPara = { late5: null, late610: null, late10: null }

  const headingOnClick = {
    'LATE<5': () => {
      setFilterParams({ ...filterParams, ...initialPara, late5: filterParams.late5 === 1 ? -1 : 1 })
    },
    'LATE>6-10': () => {
      setFilterParams({ ...filterParams, ...initialPara, late610: filterParams.late610 === 1 ? -1 : 1 })
    },
    'LATE>10': () => {
      setFilterParams({ ...filterParams, ...initialPara, late10: filterParams.late10 === 1 ? -1 : 1 })
    },
  }

  return (
    <Layout
      heading="Montly Late Report"
      none
      selectedFrom={from}
      setSelectedFrom={setFrom}
      selectedTo={to}
      setSelectedTo={setTo}
      headers={heading}
      data={tempAttendance ? tempAttendance : []}
      tempHeaderData={[]}
      filename='monthly_late_report'
    >

      <CustomModal open={open} handleClose={() => setOpen(false)}>
        {content.map((emp, index) => {
          return <li key={index}>{emp}</li>
        })}
      </CustomModal>

      <CustomTable padding className={styles.table}>
        <CustomTableHeading
          filterIcons={{
            'LATE<5': <SortIcon onClick={headingOnClick['LATE<5']} value={filterParams.late5} />,
            'LATE>6-10': <SortIcon onClick={headingOnClick['LATE>6-10']} value={filterParams.late610} />,
            'LATE>10': <SortIcon onClick={headingOnClick['LATE>10']} value={filterParams.late10} />,
          }}
          heading={['REGION', 'ZONE', 'STATE', 'DISTRICT', 'CITY', 'TSM', 'LATE<5', 'LATE>6-10', 'LATE>10']}
        />
        <TableBody className={styles.tr}>
          {!loading && attendance.length > 0 &&
            attendance.slice((page - 1) * itemsPerPage, page * itemsPerPage).map((item, index) => {
              return (
                <CustomTableRow>
                  <TableCell> {item.region ? item.region.name : '-----'} </TableCell>
                  <TableCell> {item.zone ? item.zone.name : '-----'} </TableCell>
                  <TableCell> {item.state ? item.state.name : '-----'} </TableCell>
                  <TableCell> {item.district ? item.district.name : '-----'} </TableCell>
                  <TableCell> {item.city ? item.city.name : '-----'} </TableCell>
                  <TableCell> {item.name ? item.name : '-----'} </TableCell>
                  <TableCell onClick={() => handleClick(item.late5)}> {item.late5 ? item.late5.length : ''}</TableCell>
                  <TableCell onClick={() => handleClick(item.late610)}> {item.late610 ? item.late610.length : ''}</TableCell>
                  <TableCell onClick={() => handleClick(item.late10)}> {item.late10 ? item.late10.length : ''}</TableCell>
                </CustomTableRow>
              )
            }
            )}
        </TableBody>
      </CustomTable>
      {loading && <Loader />}
      {!loading && attendance.length > 0 && (
        <CustomPagination noOfPages={noOfPages} page={page} handleChange={handleChange} />
      )}

      {!loading && attendance.length === 0 && <NoDataFound />}
    </Layout>
  )
}
